// extracted by mini-css-extract-plugin
export var container = "ut0FSwyd";
export var sign = "xhwzWjUE";
export var label = "_8+7HRSKD";
export var text = "rlmib1VK";
export var text__column = "BuLLbT6D";
export var sponsors = "TEDPv+T0";
export var sponsors__list = "AWH5hzFq";
export var sponsor__link = "KYz6SEiY";
export var sponsor__asset = "VqelBVi8";